import styled from "styled-components";
export const TableAction = styled.div`
  width: fit-content;
  height: fit-content;
`;

export const TableActionButtons = styled.div`
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  border-radius: 1px;
  background: ${({ theme }) => theme.neutral.white};
  width: 40px;
  height: 40px;
  .list-view {
    color: ${({ iconColor, theme }) => (iconColor ? theme.text.primary : theme.tabs.selected)};
  }
  .card-view {
    color: ${({ iconColor, theme }) => (iconColor ? theme.tabs.selected : theme.text.primary)};
  }
`;
